// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  list-style-type: none;
  padding: 0;
  margin: 8px 0 0 0;
  flex: 1 1;
  overflow-y: auto;
  scrollbar-width: none;
}

.menu::-webkit-scrollbar {
  display: none;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  cursor: pointer;
  margin: 2px 8px;
  transition: all 0.15s ease;
  border-radius: 8px;
  border: 2px solid transparent;
  position: relative;
  min-height: 56px;
}

.menu-item .icon {
  color: #94A3B8;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-item .label {
  color: #FFFFFF;
  transition: all 0.15s ease;
  text-align: center;
  font-size: 9px;
  font-weight: 500;
  margin-top: 4px;
  line-height: 1.2;
  letter-spacing: 0.01em;
}

.menu-item:hover {
  background-color: #0B51C5;
}

.menu-item:hover .icon,
.menu-item:hover .label {
  color: #FFFFFF;
}

/* Keyboard focus */
.menu-item:focus-visible {
  outline: none;
  border-color: #3B82F6;
  background-color: #1E293B;
}

/* Active state with left indicator */
.menu-item.active {
  background-color: #0B51C5;
}

.menu-item.active::before {
  content: '';
  position: absolute;
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  background-color: #FFFFFF;
  border-radius: 0 3px 3px 0;
}

.menu-item.active .icon,
.menu-item.active .label {
  color: #FFFFFF;
}

.menu-item.active:hover {
  background-color:  #0B51C5;
}

/* SVG icon defaults */
.subsidebar_icon svg {
  color: #FFFFFF;
  stroke: #FFFFFF;
  transition: all 0.15s ease;
  width: 20px;
  height: 20px;
}

.menu-item:hover .subsidebar_icon svg {
  color: #E2E8F0;
  stroke: #E2E8F0;
}

.subsidebar_icon.active svg,
.menu-item.active .subsidebar_icon svg {
  color: #FFFFFF;
  stroke: #FFFFFF;
}

/* Responsive: hide labels on medium */
@media (max-width: 1024px) {
  .menu-item .label {
    display: none;
  }
  .menu-item {
    padding: 10px 4px;
    margin: 2px 6px;
    min-height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/sidebar/styles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,UAAU;EACV,iBAAiB;EACjB,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".menu {\n  list-style-type: none;\n  padding: 0;\n  margin: 8px 0 0 0;\n  flex: 1;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n.menu::-webkit-scrollbar {\n  display: none;\n}\n\n.menu-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 4px;\n  cursor: pointer;\n  margin: 2px 8px;\n  transition: all 0.15s ease;\n  border-radius: 8px;\n  border: 2px solid transparent;\n  position: relative;\n  min-height: 56px;\n}\n\n.menu-item .icon {\n  color: #94A3B8;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.menu-item .label {\n  color: #FFFFFF;\n  transition: all 0.15s ease;\n  text-align: center;\n  font-size: 9px;\n  font-weight: 500;\n  margin-top: 4px;\n  line-height: 1.2;\n  letter-spacing: 0.01em;\n}\n\n.menu-item:hover {\n  background-color: #0B51C5;\n}\n\n.menu-item:hover .icon,\n.menu-item:hover .label {\n  color: #FFFFFF;\n}\n\n/* Keyboard focus */\n.menu-item:focus-visible {\n  outline: none;\n  border-color: #3B82F6;\n  background-color: #1E293B;\n}\n\n/* Active state with left indicator */\n.menu-item.active {\n  background-color: #0B51C5;\n}\n\n.menu-item.active::before {\n  content: '';\n  position: absolute;\n  left: -8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 20px;\n  background-color: #FFFFFF;\n  border-radius: 0 3px 3px 0;\n}\n\n.menu-item.active .icon,\n.menu-item.active .label {\n  color: #FFFFFF;\n}\n\n.menu-item.active:hover {\n  background-color:  #0B51C5;\n}\n\n/* SVG icon defaults */\n.subsidebar_icon svg {\n  color: #FFFFFF;\n  stroke: #FFFFFF;\n  transition: all 0.15s ease;\n  width: 20px;\n  height: 20px;\n}\n\n.menu-item:hover .subsidebar_icon svg {\n  color: #E2E8F0;\n  stroke: #E2E8F0;\n}\n\n.subsidebar_icon.active svg,\n.menu-item.active .subsidebar_icon svg {\n  color: #FFFFFF;\n  stroke: #FFFFFF;\n}\n\n/* Responsive: hide labels on medium */\n@media (max-width: 1024px) {\n  .menu-item .label {\n    display: none;\n  }\n  .menu-item {\n    padding: 10px 4px;\n    margin: 2px 6px;\n    min-height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
